import { render, staticRenderFns } from "./billing-modal-delivery-notes-crud-grid.vue?vue&type=template&id=350c7451&scoped=true&"
import script from "./billing-modal-delivery-notes-crud-grid.ts?vue&type=script&lang=ts&"
export * from "./billing-modal-delivery-notes-crud-grid.ts?vue&type=script&lang=ts&"
import style0 from "./billing-modal-delivery-notes-crud-grid.scss?vue&type=style&index=0&id=350c7451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c7451",
  null
  
)

export default component.exports